// src/pages/AdminPage.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeCtx } from "../App";
import {
  BarChart3,
  Settings,
  Upload,
  Table2Icon,
  UserCircle,
  DatabaseIcon,
  TruckIcon,
  UsersIcon,
  File,
  LucideDollarSign,
  SettingsIcon,
  UserPlus2Icon,
  LucideTractor,
  Wrench,
} from "lucide-react";
import "../App.css";

export default function AdminPage() {
  const nav = useNavigate();
  const { theme, setTheme } = useContext(ThemeCtx);

  const tiles = [
    {
      to: "/admin/customers",
      label: "Manage Customers",
      sub: "Add / Edit / Delete Customers",
      icon: UserPlus2Icon,
    },
    {
      to: "/admin/vendors",
      label: "Manage Vendors",
      sub: "Add / Edit / Delete Vendors",
      icon: LucideTractor,
    },
    {
      to: "/reports",
      label: "Reports",
      sub: "Stats + analytics",
      icon: BarChart3,
    },
    {
      to: "/builder-upload",
      label: "Sync Labrie Open Orders",
      sub: "Upload the weekly Labrie production update",
      icon: Upload,
    },
    {
      to: "/admin/users",
      label: "Users",
      sub: "List / Add / Edit / Delete",
      icon: UserCircle,
    },
    {
      to: "/admin/schema",
      label: "Schema Manager",
      sub: "Edit Tables",
      icon: Table2Icon,
    },
    {
      to: "/admin/dbs",
      label: "Database Settings",
      sub: "Add / Edit / Delete Databases",
      icon: DatabaseIcon,
    },
    {
      to: "/admin/devtools",
      label: "Developer Tools",
      sub: "Importer, schema, DB registry",
      icon: Wrench,
    },
    {
      to: "/admin/moves",
      label: "Drive-Away",
      sub: "Unit Movement Operations",
      icon: TruckIcon,
    },
    {
      to: "/admin/driver-mgmt",
      label: "Drivers",
      sub: "Manage Drivers",
      icon: UsersIcon,
    },
    {
      to: "/admin/settings",
      label: "Settings",
      sub: "Manage Settings",
      icon: SettingsIcon,
    },
    {
      to: "/admin/api-keys",
      label: "Api Key Managment",
      sub: "Manager third party integrations",
      icon: LucideDollarSign,
    },
    {
      to: "/admin",
      label: "Generate Sales Brochure",
      sub: "Paid Upgrade - Use Ai to generate a sales brochure for any selected unit",
      icon: File,
      gated: true,
    },
    {
      to: "/admin",
      label: "CRM Integration",
      sub: "Update salesman with production schedules with Pick up and Delivery notifications",
      icon: LucideDollarSign,
      gated: true,
    },
    {
      to: "/admin",
      label: "Social Integration",
      sub: "Automatically congragulate customers upon driver delivery update",
      icon: LucideDollarSign,
      gated: true,
    },
    {
      to: "/admin",
      label: "Service Dept. Integration",
      sub: "integrate IMS with your service department",
      icon: LucideDollarSign,
      gated: true,
    },
    {
      to: "/admin",
      label: "Quoting Integration",
      sub: "Generate Quotes within IMS at the click of a button",
      icon: LucideDollarSign,
      gated: true,
    },
    {
      to: "/admin",
      label: "Ai Integration",
      sub: "Coming Soon",
      icon: LucideDollarSign,
      gated: true,
    },
  ];

  return (
    <div className="container">
      <div className="splash">
        <div style={{ width: "100%" }}>
          <div
            className="row"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <div>
              <div className="splash-title">Admin Tools</div>
              <div className="splash-sub">
                Manage Users • Data Management • UX Settings • Reporting •
                Importing/Exporting
              </div>
            </div>

            <div
              className="row"
              style={{ gap: 10, flexWrap: "wrap", justifyContent: "flex-end" }}
            >
              <div className="row" style={{ gap: 8, alignItems: "center" }}>
                <Settings size={16} style={{ opacity: 0.8 }} />
                <select
                  className="input"
                  style={{ width: 150 }}
                  value={theme}
                  onChange={(e) => setTheme(e.target.value)}
                  title="Theme"
                >
                  <option value="system">System</option>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                </select>
              </div>
              <button className="btn-outline" onClick={() => nav("/home")}>
                Home
              </button>
            </div>
          </div>

          <div className="scan-grid" style={{ marginTop: 16 }}>
            {tiles.map((t) => {
              const Icon = t.icon;
              return (
                <button
                  key={t.label}
                  className={`scan-tile ${t.gated ? "scan-tile-gated" : ""}`}
                  onClick={() => {
                    if (!t.gated) nav(t.to);
                  }}
                  disabled={t.gated}
                >
                  <div className="scan-tile-top">
                    <div className="scan-icon">
                      <Icon size={22} />
                    </div>
                    <div className="scan-chev">↗</div>
                  </div>
                  <div className="scan-title">{t.label}</div>
                  <div className="scan-sub">{t.sub}</div>
                </button>
              );
            })}
          </div>

          <div className="muted" style={{ marginTop: 14 }}></div>
        </div>
      </div>
    </div>
  );
}
